import React, { useState, useEffect } from "react";
import fetchData from "../../services/requester-website";
import parse from "html-react-parser";

const HomeTestimonials = () => {
  const [data, setData] = useState([]);

  const getData = () => {
    let reqURL = "testimonials";
    let reqOBJ = "";
    fetchData(
      reqURL,
      reqOBJ,
      (data) => {
        data && setData(data || []);
      },
      "GET"
    );
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    data &&
    data.length > 0 && (
      <div className="home-testimonials">
        <h2 className="home-title">Echoes of Happy Customers</h2>
        <p className="home-sub-title">
          Unveiling the Heartwarming Tales That Illuminate the Path to Our
          Success!
        </p>
        <div className="row">
          {data?.map(
            (x, key) =>
              key < 4 && (
                <div key={key} className="col-lg-3">
                  <div className="home-testimonials-wrap">
                    <h3>{x?.title}</h3>
                    <h4>{x?.subTitle}</h4>
                    <div>{parse("" + x?.description + "")}</div>
                  </div>
                </div>
              )
          )}
        </div>
      </div>
    )
  );
};

export default HomeTestimonials;
